<template>
<div class="content">
	<!-- Content Header (Page header) -->
	<section class="content-header">
		<div class="container-fluid">
			<div class="page-header clearfix">
				<h1>{{ $t($route.name) }}</h1>
				<div class="pull-right">
					<router-link data-toggle="tooltip" title="Добави" class="btn btn-success" to="/moderate/category/new"><i class="fa fa-plus"></i></router-link>
				</div>
			</div>
		</div>
	</section>
	<!-- Main Content -->
	<div class="container-fluid" v-if="dataReady">
		<div class="card">
			<div class="card-block">
				<category-tree :category-id="0"></category-tree>
			</div>
		</div>
		<!-- end of card -->
	</div>
</div>
</template>

<script>
module.exports = {
	data: function() {
		return {
			items: [],
			total: 0,
			dataReady: false
		};
	},
	created: function() {
		this.fetchData();
	},
	watch: {
		$route: 'fetchData'
	},
	methods: {
		fetchData: function() {
			this.$http.get('backend://category').then((response) => {
				this.items = response.body.items;
				this.total = response.body.total;
				this.pages = Math.ceil(this.total / this.rpp);
				this.dataReady = true;
			}).catch(this.$http.toastCatcher);
		},

		remove: function(id) {
			this.$http.delete('backend://category/' + id).then((result) => {
				this.fetchData();
			}).catch(this.$http.toastCatcher);
		}
	},
	components: {
		'category-tree': require('./CategoryTree.vue')
	}
};
</script>
<style>

</style>



// WEBPACK FOOTER //
// CategoryList.vue?8743f4d6